<div class="container-scroller">
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper d-flex align-items-center text-center error-page" style="background-color: #46c35f;">
      <div class="row flex-grow">
        <div class="col-lg-7 mx-auto text-white">
          <div class="row align-items-center d-flex flex-row">
            <div class="col-lg-12  pr-lg-4">
              <h1 style="font-size: 6em;" class="display-1 mb-0">Success</h1>
            </div>
            <div class="col-lg-12 error-page-divider pl-lg-4">
              <h2>Congratulations.</h2>
              <h3 class="font-weight-light"> Please wait for a moment..........</h3>
              <h3 class="font-weight-light"> <a [href]="sanitize(mainURLForOpenApp)"  id="clickForApp" style="display: none;">Click here to open app</a></h3>
            </div>
           </div>
          <div class="row mt-5">
            <div class="col-12 text-center mt-xl-2">
              <a class="text-white font-weight-medium">Back to home</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- content-wrapper ends -->
  </div>
  <!-- page-body-wrapper ends -->
</div>
